namespace Matrix.Data {
    export class CreditRatingColumns {
        static columnsKey = 'Data.CreditRating';
    }
}
